import { render, staticRenderFns } from "./ShowAsDialog.vue?vue&type=template&id=f89fc208"
import script from "./ShowAsDialog.vue?vue&type=script&lang=js"
export * from "./ShowAsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports